(() => {
  const enhance = (root = document) => {
    root.querySelectorAll('.wf-nutrition-source:not([data-nutrition-ready])').forEach(source => {
      const rich = source.querySelector('.metafield-rich_text_field');
      if (!rich) return;
      const nodes = Array.from(rich.children);
      if (!nodes.some(n => n.textContent.trim() === 'Nutrient | Amount per serving | %DV / NRV*')) return;
      const fragment = document.createDocumentFragment();
      let panel = null;
      let body = null;
      const make = (tag, value, className) => {
        const el = document.createElement(tag);
        if (value !== undefined) el.textContent = value;
        if (className) el.className = className;
        return el;
      };
      for (const node of nodes) {
        const value = node.textContent.trim();
        if (node.tagName === 'H2' && value === 'Nutrition Facts') {
          panel = make('section', undefined, 'wf-nutrition');
          panel.setAttribute('aria-label', value);
          panel.append(make('h2', value));
          fragment.append(panel);
          body = null;
        } else if (!panel) {
          fragment.append(node.cloneNode(true));
        } else if (value === 'Nutrient | Amount per serving | %DV / NRV*') {
          const table = make('table', undefined, 'wf-nutrition-table');
          const head = make('thead');
          const row = make('tr');
          value.split('|').forEach(label => {
            const cell = make('th', label.trim());
            cell.scope = 'col';
            row.append(cell);
          });
          head.append(row);
          body = make('tbody');
          table.append(head, body);
          panel.append(table);
        } else if (body && value.split('|').length === 3) {
          const row = make('tr', undefined, node.querySelector('strong,b') ? 'strong' : '');
          value.split('|').forEach((part, index) => {
            const cell = make(index === 0 ? 'th' : 'td', part.trim());
            if (index === 0) cell.scope = 'row';
            row.append(cell);
          });
          body.append(row);
        } else if (body && !value.startsWith('*') && node.querySelector('strong,b')) {
          const row = make('tr', undefined, 'wf-nutrition-group');
          const cell = make('td', value);
          cell.colSpan = 3;
          row.append(cell);
          body.append(row);
        } else {
          panel.append(make('p', value, body ? 'wf-nutrition-note' : value.startsWith('Flavor:') ? 'flavor' : 'meta'));
        }
      }
      source.replaceChildren(fragment);
      source.dataset.nutritionReady = 'true';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(), {once:true});
  else enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
